var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsAiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.426,
    height: 19.527,
    viewBox: "0 0 18.426 19.527",
    className: "ai-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-linear-gradient",
    x1: 0.137,
    x2: 0.834,
    y2: 0.913,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-gradient-1, #369bf3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "var(--icon-gradient-2, #2a78e8)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "var(--icon-gradient-3, #2b7ce9)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-gradient-4, #163cd6)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M9.826,18.527a.208.208,0,0,1-.2-.171,9.544,9.544,0,0,0-7.233-7.469.212.212,0,0,1-.165-.208h0a.212.212,0,0,1,.165-.208A9.268,9.268,0,0,0,7.08,7.842,9.754,9.754,0,0,0,9.625,3a.2.2,0,0,1,.4,0,9.754,9.754,0,0,0,2.545,4.842,9.265,9.265,0,0,0,4.688,2.628.214.214,0,0,1,0,.417,9.266,9.266,0,0,0-4.688,2.628,9.752,9.752,0,0,0-2.545,4.841.208.208,0,0,1-.2.171ZM3.506,7.357A4.522,4.522,0,0,0,.078,3.818a.1.1,0,0,1,0-.2A4.392,4.392,0,0,0,2.3,2.375,4.623,4.623,0,0,0,3.506.081a.1.1,0,0,1,.191,0A4.622,4.622,0,0,0,4.9,2.375,4.391,4.391,0,0,0,7.124,3.621a.1.1,0,0,1,0,.2A4.39,4.39,0,0,0,4.9,5.063,4.62,4.62,0,0,0,3.7,7.357a.1.1,0,0,1-.191,0Z",
    transform: "translate(0.5 0.5)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.89,
    fill: "url(#ai-linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsAiIcon);
export default __webpack_public_path__ + "static/media/newsAiIcon.aaa97bdf375e8fbc3242207c506ad118.svg";
export { ForwardRef as ReactComponent };